import { LogLevel } from "@azure/msal-browser";

export const b2cPolicies = {
  authorities: {
    signUpSignIn: {
      authority: `https://${process.env.REACT_APP_B2C_POLICIES_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_B2C_POLICIES_TENANT_NAME}.onmicrosoft.com/${process.env.REACT_APP_B2C_SIGN_IN}`,
    },
  },
  authorityDomain: `${process.env.REACT_APP_B2C_POLICIES_TENANT_NAME}.b2clogin.com`,
};

export const msalConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_MSAL_CONFIG_CLIENT_ID}`,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: process.env.REACT_APP_REDIRECT_URL,
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};
